// Angular
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  Input,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import {
  LayoutConfigService,
  MenuConfigService,
  MenuHorizontalService,
  MenuOptions,
  OffcanvasOptions
} from '../../../../core/_base/layout';
// HTML Class
import { HtmlClassService } from '../../html-class.service';
import { ProjectService } from '../../../pages/services/project.service';
import { UserService } from '../../../pages/services/user.service';
import { User } from '../../../../core/auth/_models/user.model';
import { UserDetailDialogComponent } from '../../../pages/user-management/user-detail-dialog/user-detail-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MasterEntityService } from '../../../pages/services/masterentity.service';

@Component({
  selector: 'kt-menu-horizontal',
  templateUrl: './menu-horizontal.component.html',
  styleUrls: ['./menu-horizontal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MenuHorizontalComponent implements OnInit, AfterViewInit {
  isDrawingComponentActive = false;
  menuItems: any[] = [];
  isHomeComponentActive = false;
  private offcanvas: any;
  role: string;
  userid: any;
  user: User;
  username: any;
  @ViewChild('headerMenuOffcanvas', { static: true }) headerMenuOffcanvas: ElementRef;

  @Input() headerLogo: string;
  @Input() headerMenuSelfDisplay: boolean;
  @Input() headerMenuClasses: string;
  // Public properties
  currentRouteUrl: any = '';
  asideSelfDisplay = '';
  rootArrowEnabled: boolean;
  projectTitle: string;
  menuOptions: MenuOptions = {
    submenu: {
      desktop: 'dropdown',
      tablet: 'accordion',
      mobile: 'accordion'
    },
    accordion: {
      slideSpeed: 200, // accordion toggle slide speed in milliseconds
      expandAll: false // allow having multiple expanded accordions in the menu
    },
    dropdown: {
      timeout: 50
    }
  };

  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'header-menu-wrapper',
    closeBy: 'kt_header_menu_mobile_close_btn',
    toggleBy: {
      target: 'kt_header_mobile_toggle',
      state: 'mobile-toggle-active'
    }
  };
  LogedUserCompany: string;
  isPermittedForPriceUpdate = false;

  /**
   * Component Conctructor
   *
   * @param el: ElementRef
   * @param htmlClassService: HtmlClassService
   * @param menuHorService: MenuHorService
   * @param menuConfigService: MenuConfigService
   * @param layoutConfigService: LayouConfigService
   * @param router: Router
   * @param render: Renderer2
   * @param cdr: ChangeDetectorRef
   */
  constructor(
    private el: ElementRef,
    public htmlClassService: HtmlClassService,
    public menuHorService: MenuHorizontalService,
    private menuConfigService: MenuConfigService,
    private layoutConfigService: LayoutConfigService,
    private router: Router,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
    public projectService: ProjectService,
    private userService: UserService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private masterEntityService: MasterEntityService, 
  ) {
 this.isHomeComponentActive = true;
  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      const routePath = this.route.snapshot.firstChild?.routeConfig?.path;
      if (routePath === 'drawing') {
        this.isDrawingComponentActive = true;
        this.isHomeComponentActive = false;
      } else if (routePath === 'home' || routePath === '') {
        this.isHomeComponentActive = true;
        this.isDrawingComponentActive = false;
      } else {
        this.isDrawingComponentActive = false;
        this.isHomeComponentActive = false;
      }
    });
 
  this.projectService.projectTitle$.subscribe((title) => {
    this.projectTitle = title;
    this.cdr.markForCheck();
  });
 
  this.username = localStorage.getItem('username');
  this.userid   = localStorage.getItem('userId');
 
  this.userService.getUserById(this.userid).subscribe(
    (user) => {
      this.role = user.role;
      this.user = user;
    },
    (error) => {
      console.error('Error fetching users by userId', error);
    }
  );
 
  this.userService.subscribeToLogoUploaded().subscribe((logo: string) => {
    this.user.profilePicture = logo;
  });
 
  this.userService.getLogeduserCompany(this.userid).subscribe(res => {
    this.LogedUserCompany = (res.companyName || res.distributorCompanyName || '').toLowerCase().trim();
 
    // Once we know the company, check price permission for Eltech non-admin users
    if (this.LogedUserCompany === 'eltech') {
      this.masterEntityService.checkPermission(this.userid).subscribe(result => {
        this.isPermittedForPriceUpdate = result.permitted;
        // Re-filter menu items now that permission is known
        this.menuItems = this.getBaseMenuItems().filter(item => this.showMenuItem(item));
        this.cdr.markForCheck();
      });
    }
  });
}
private getBaseMenuItems() {
  return [
    { title: 'Home' },
    { title: 'Projects' },
    { title: 'Master Entity' },
    { title: 'Customer' },
    { title: 'User Management' },
    { title: 'Sign out' },
  ];
}
showMenuItem(item: any): boolean {
  const isEltech = this.LogedUserCompany === 'eltech';
 
  if (this.role === 'superadmin') {
    return true;
  }
 
  if (this.role === 'admin' && isEltech) {
    // Eltech admin: sees Master Entity, but NOT User Management or Dashboards
    return item.title !== 'User Management' && item.title !== 'Dashboards';
  }
 
  if (this.role === 'admin' && !isEltech) {
    // Non-eltech admin: no Master Entity, no User Management, no Dashboards
    return item.title !== 'Master Entity'
      && item.title !== 'User Management'
      && item.title !== 'Dashboards';
  }
 
  // Eltech non-admin: show Master Entity only if they have price-update permission
  if (isEltech) {
    if (item.title === 'Master Entity') {
      return this.isPermittedForPriceUpdate;
    }
    return item.title !== 'User Management' && item.title !== 'Dashboards';
  }
 
  // All other roles (guestuser, localuser, etc.)
  return item.title !== 'Master Entity'
    && item.title !== 'User Management'
    && item.title !== 'Dashboards';
}
  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * After view init
   */
  ngAfterViewInit(): void {
  }

  /**
   * On init
   */
ngOnInit(): void {
  this.rootArrowEnabled = this.layoutConfigService.getConfig('header.menu.self.rootArrow');
  this.currentRouteUrl  = this.router.url;
 
  this.userService.getUserById(this.userid).subscribe(
    (user) => {
      this.role = user.role;
      this.menuItems = this.getBaseMenuItems().filter(item => this.showMenuItem(item));
      setTimeout(() => {
        this.offcanvas = new KTOffcanvas(
          this.headerMenuOffcanvas.nativeElement,
          this.offcanvasOptions
        );
      });
      this.cdr.markForCheck();
    },
    (error) => {
      console.error('Error fetching users by userId', error);
    }
  );
 
  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(event => {
      this.currentRouteUrl = this.router.url;
      this.mobileMenuClose();
      this.cdr.markForCheck();
    });
}


  /**
   * Return Css Class Name
   * @param item: any
   */
  getItemCssClasses(item) {
    let classes = 'menu-item';

    if (objectPath.get(item, 'submenu')) {
      classes += ' menu-item-submenu';
    }

    if (!item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-active menu-item-here';
    }

    if (item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-open menu-item-here';
    }

    if (objectPath.get(item, 'resizer')) {
      classes += ' menu-item-resize';
    }

    const menuType = objectPath.get(item, 'submenu.type') || 'classic';
    if ((objectPath.get(item, 'root') && menuType === 'classic')
      || parseInt(objectPath.get(item, 'submenu.width'), 10) > 0) {
      classes += ' menu-item-rel';
    }

    const customClass = objectPath.get(item, 'custom-class');
    if (customClass) {
      classes += ' ' + customClass;
    }

    if (objectPath.get(item, 'icon-only')) {
      classes += ' menu-item-icon-only';
    }

    return classes;
  }

  /**
   * Returns Attribute SubMenu Toggle
   * @param item: any
   */
  getItemAttrSubmenuToggle(item) {
    let toggle = 'hover';
    if (objectPath.get(item, 'toggle') === 'click') {
      toggle = 'click';
    } else if (objectPath.get(item, 'submenu.type') === 'tabs') {
      toggle = 'tabs';
    } else {
      // submenu toggle default to 'hover'
    }

    return toggle;
  }

  /**
   * Returns Submenu CSS Class Name
   * @param item: any
   */
  getItemMenuSubmenuClass(item) {
    let classes = '';

    const alignment = objectPath.get(item, 'alignment') || 'right';

    if (alignment) {
      classes += ' menu-submenu-' + alignment;
    }

    const type = objectPath.get(item, 'type') || 'classic';
    if (type === 'classic') {
      classes += ' menu-submenu-classic';
    }
    if (type === 'tabs') {
      classes += ' menu-submenu-tabs';
    }
    if (type === 'mega') {
      if (objectPath.get(item, 'width')) {
        classes += ' menu-submenu-fixed';
      }
    }

    if (objectPath.get(item, 'pull')) {
      classes += ' menu-submenu-pull';
    }

    return classes;
  }

  /**
   * Check Menu is active
   * @param item: any
   */
  isMenuItemIsActive(item): boolean {
    if (item.submenu) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.page) {
      return false;
    }

    return this.currentRouteUrl.indexOf(item.page) !== -1;
  }

  /**
   * Check Menu Root Item is active
   * @param item: any
   */
  isMenuRootItemIsActive(item): boolean {
    if (item.submenu.items) {
      for (const subItem of item.submenu.items) {
        if (this.isMenuItemIsActive(subItem)) {
          return true;
        }
      }
    }

    if (item.submenu.columns) {
      for (const subItem of item.submenu.columns) {
        if (this.isMenuItemIsActive(subItem)) {
          return true;
        }
      }
    }

    if (typeof item.submenu[Symbol.iterator] === 'function') {
      for (const subItem of item.submenu) {
        const active = this.isMenuItemIsActive(subItem);
        if (active) {
          return true;
        }
      }
    }

    return false;
  }

  mobileMenuClose() {
    if (KTUtil.isBreakpointDown('lg') && this.offcanvas) { // Tablet and mobile mode
      this.offcanvas.hide(); // Hide offcanvas after general link click
    }
  }
  logout(): void {
    // Call the logoutUser function from the userService
    console.log('logout');
    if (this.userid) {
      this.userService.logoutUser();
    }
    // Navigate to the login page after logging out
    this.router.navigateByUrl('/auth/login');

  }
  handleImageError(user: User) {
    // If there's an error loading the image or the profilePicture is not available
    if (user && !user.profilePicture) {
      // Set a default image URL using the user's full name
      user.profilePicture = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.fullname.charAt(0)) + '&background=random';
    }
  }
  openUserDetailsDialog(): void {
    const dialogRef = this.dialog.open(UserDetailDialogComponent, {
      maxWidth: '30vw', // Adjust width as per your requirement
      maxHeight: '30vw',
      data: { user: this.user }, // Pass the user details to the dialog box component
      position: {
        right: '0', // Position the dialog box on the right side of the screen
        top: '65px',

      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


}
